import { injectSportsApiClient } from '@collector/shared-ui-domain'
import type {
  Event,
  Participant,
  SubParticipant,
} from '@collector/sportsapi-types'

import { getTeamIdToSubParticipantsMap } from '../utils/model.utils'

export function useSubParticipants(): {
  fetchParticipantSubParticipants: (
    eventId: number,
    participantId: number,
  ) => Promise<SubParticipant[]>
} {
  const sportsApiClient = injectSportsApiClient()

  async function fetchParticipantSubParticipants(
    eventId: Event['id'],
    participantId: Participant['id'],
  ): Promise<SubParticipant[]> {
    const subParticipants =
      await sportsApiClient.Events.SubParticipants.get(eventId)
    const teamIdToSubParticipantsMap = getTeamIdToSubParticipantsMap(
      subParticipants.api.data.sub_participants,
    )
    return teamIdToSubParticipantsMap[participantId] || []
  }

  return {
    fetchParticipantSubParticipants,
  }
}
